import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import ErrorsGridLayout from './containers/Grid';

export default function ErrorLayout() {
  return <Router>
    <PrivateRoute path="/admin/app-error" component={ErrorsGridLayout} />
  </Router>;
}
